import { queryOptions } from '@tanstack/react-query'
import { conceptGet } from 'Concept/api/ConceptApi'

import { MinutesToMilliseconds } from 'Common/utils/helpers/HelperTime'

export const conceptQueries = {
    all: () => ['concepts'],
    details: () => [...conceptQueries.all(), 'detail'],
    detailKey: (id: number) => [...conceptQueries.details(), id] as const,
    detail: (id: number) =>
        queryOptions({
            queryKey: [...conceptQueries.details(), id],
            queryFn: () => conceptGet(id),
            staleTime: MinutesToMilliseconds(10),
        }),
}
